import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/translationKeys'
import { reverseArray } from 'utils/reverseArray'

export interface WhoWeAreProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useWhoWeAre = (props: WhoWeAreProps) => {
  const whoWeAreData = useSelector((state: RootState) => state.about.whoWeAre)

  const animations = ['fadeInRight', 'fadeInDown', 'fadeInUp', 'fadeInLeft']
  const animationsReversed = reverseArray(animations)

  return {
    ...props,
    whoWeAreData,
    animations,
    animationsReversed,
  }
}
